import { ProductListParams } from '@graphcommerce/magento-product/components/ProductListItems/filterTypes'
import { ProductListPaginationFragment } from '@graphcommerce/magento-product/components/ProductListPagination/ProductListPagination.gql'
import { Trans } from '@lingui/react'
import { Pagination, PaginationProps } from '@mui/material'
import { useCallback } from 'react'
import { useProductListLinkReplace } from '../../../hooks/Product/useProductListLinkReplace'
import { Icon } from '../../Layout/Icon'

export type ProductPaginationProps = ProductListPaginationFragment &
  Omit<PaginationProps, 'count' | 'defaultPage' | 'page' | 'renderItem'> & {
    params: ProductListParams
  }

export function ProductListPagination({
  page_info,
  params,
  ...paginationProps
}: ProductPaginationProps) {
  const replaceRoute = useProductListLinkReplace({ scroll: false })

  const handleChangePage = (event: React.ChangeEvent<unknown>, value: number) => {
    replaceRoute({ ...params, currentPage: value })
  }

  // if (!page_info || !page_info.total_pages || !page_info.current_page) return null

  return (
    <div className='flex cursor-pointer items-center justify-center gap-[16px]'>
      <Pagination
        onChange={handleChangePage}
        count={page_info?.total_pages ?? 0}
        shape='rounded'
        showFirstButton
        showLastButton
        color='secondary'
      />
    </div>
  )
}
